<template>
  <div class="page logos">
    <h1>Logo's</h1>
    <div class="form">
      <div class="form__field">
        <label>Zoeken</label><input type="text" class="input" v-model="search" @focusin="search=''">
      </div>
    </div>
    <div class="page__content">
      <div class="logos__options" v-if="logos.length">
        <div class="button logos__options__option" v-for="(item, index) in filteredLogos" :key="`logo--${index}`"
             @click="activeAsset=`${item.pathLong}`">
          <div class="logos__options__option__thumb">
            <img :src="item.pathLong" :alt="item.label">
          </div>
          <p>{{ item.label }}</p>
        </div>
      </div>
    </div>
    <AssetModal v-if="activeAsset" :asset="activeAsset" @close-asset="activeAsset=null"></AssetModal>
  </div>
</template>

<script>
import AssetModal from "@/components/AssetModal";

export default {
  name: "Logos",
  components: {AssetModal},
  data() {
    return {
      logos: [],
      search: "",
      activeAsset: null
    }
  },
  mounted() {
    this.importLogos(require.context('@/assets/media/klantenlogos/', true, /\.jpg$/));
  },
  computed: {
    filteredLogos() {
      if (!this.search) {
        return this.logos;
      }
      return this.logos.filter(l => l.label.toLowerCase().match(this.search.toLowerCase()));
    },
  },
  methods: {
    importLogos(r) {
      r.keys().forEach(key => (this.logos.push({label: this.getName(key), pathLong: r(key), pathShort: key})));
    },

    getName(key) {
      return key.split(".")[1].substring(1, key.length);
    }
  }
}
</script>
